import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/5Z2mmmU49Mvmjq9QJs21jD/Captura_de_pantalla_2026-05-15_a_las_17.15.09-removebg-preview.png';
const navLinks = [{
  name: 'Inicio',
  path: '/'
}, {
  name: 'Menú',
  path: '/menu'
}, {
  name: 'Sobre Nosotros',
  path: '/sobre'
}, {
  name: 'Donaciones',
  path: '/donaciones'
}, {
  name: 'Contacto',
  path: '/contacto'
}];
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);
  return <header className="fixed top-0 left-0 right-0 z-50 glass-nav" data-id="element-149">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-150">
        <div className="flex justify-between items-center h-20" data-id="element-151">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0 flex items-center" onClick={closeMenu} data-id="element-152">
            <img src={LOGO_URL} alt="Trastienda Café" className="h-14 w-auto object-contain" data-id="element-153" />
          </Link>
          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-154">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium transition-colors hover:text-cafe-accent ${location.pathname === link.path ? 'text-cafe-accent' : 'text-cafe-text'}`} data-id="element-155">
                {link.name}
              </Link>)}
            <Link to="/reservas" className="bg-cafe-primary text-white px-5 py-2.5 rounded-full text-sm font-medium hover:bg-cafe-accent transition-colors shadow-sm" data-id="element-156">
              Reservar mesa
            </Link>
          </nav>
          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-157">
            <button onClick={toggleMenu} className="text-cafe-primary hover:text-cafe-accent focus:outline-none p-2" aria-label="Toggle menu" data-id="element-158">
              {isOpen ? <X size={24} data-id="element-159" /> : <Menu size={24} data-id="element-160" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile Nav */}
      <AnimatePresence data-id="element-161">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-cafe-bg border-b border-cafe-border overflow-hidden" data-id="element-162">
            <div className="px-4 pt-2 pb-6 space-y-1 flex flex-col" data-id="element-163">
              {navLinks.map(link => <Link key={link.path} to={link.path} onClick={closeMenu} className={`block px-3 py-3 text-base font-medium rounded-md ${location.pathname === link.path ? 'bg-cafe-card text-cafe-accent' : 'text-cafe-text hover:bg-cafe-card hover:text-cafe-accent'}`} data-id="element-164">
                  {link.name}
                </Link>)}
              <div className="pt-4 px-3" data-id="element-165">
                <Link to="/reservas" onClick={closeMenu} className="block w-full text-center bg-cafe-primary text-white px-5 py-3 rounded-md text-base font-medium hover:bg-cafe-accent transition-colors" data-id="element-166">
                  Reservar mesa
                </Link>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}